// Marshallese (mh) copy is a DRAFT — please have a native speaker review every line.
export const strings = {
  en: {
    "nav.home": "Home",
    "nav.about": "About",
    "nav.sermons": "Messages",
    "nav.gallery": "Events/Programs",
    "events.over": "Photos & Videos",
    "nav.pastors": "Pastors",
    "pastors.over": "Our Pastors",
    "pastors.title": "Pastors & Speakers",
    "pastors.lead": "Meet the pastors who share God's Word on Awa In Kelet, and find all of their messages and notes in one place.",
    "pastors.messages": "messages",
    "pastors.empty": "Pastor profiles are coming soon.",
    "pastors.files": "Sermon files",
    "pastors.filesCount": "sermon files",
    "pastors.noFiles": "No sermon files yet.",
    "pastors.all": "All pastors",
    "pastors.messagesBy": "Messages",
    "pastors.noMessages": "No messages yet.",
    "events.title": "Events & Programs",
    "events.lead": "Photos and videos from our programs, events and ministry across the islands.",
    "events.empty": "No photos or videos yet.",
    "events.items": "photos & videos",
    "events.deptLead": "Photos and videos from this department's programs and events.",
    "events.all": "All departments",
    "events.more": "More photos & videos",
    "sermons.pastor": "All pastors",
    "sermons.watch": "Watch video",
    "nav.donate": "Give",
    "nav.contact": "Contact",
    "cta.listen": "Listen Live",
    "cta.explore": "Explore Messages",
    "hero.title1": "Awa In",
    "hero.title2": "Kelet.",
    "hero.over": "Christian Radio · Marshall Islands",
    "hero.tagline": "Time to Choose — Jesus or the World.",
    "hero.sub": "A voice of hope carried across the atolls. Gospel preaching, island hymns, and the Word of God — day and night.",
    "hero.scroll": "Scroll",
    "marquee": "Awa In Kelet ✝ Time to Choose ✝ Jesus or the World ✝ Iakwe ✝ The Word Across the Atolls ✝",
    "choice.over": "The Choice",
    "choice.title": "Two roads. One choice.",
    "choice.world": "The World",
    "choice.worldText": "Wide is the gate and broad is the road. It promises much, and leaves the heart empty.",
    "choice.jesus": "Jesus",
    "choice.jesusText": "\"I am the way, the truth, and the life.\" A narrow road — and it leads home.",
    "choice.verse": "Choose this day whom you will serve — Joshua 24:15",
    "featured.over": "On Demand",
    "featured.title": "Recent Messages",
    "featured.all": "All messages",
    "schedule.over": "On Air",
    "schedule.title": "Daily Broadcast",
    "schedule.note": "[Placeholder schedule — update with your real program times]",
    "give.title": "Keep the Word on the air.",
    "give.text": "Your tithes and offerings carry the Gospel to every island home.",
    "give.cta": "Give Now",
    "about.over": "About the Station",
    "about.title": "A station built on one question.",
    "about.lead": "Awa In Kelet means \"Time to Choose.\" Every broadcast invites the listener to the most important decision of a life: to follow Jesus, or to follow the world.",
    "about.missionTitle": "Our Mission",
    "about.mission": "To carry the Gospel of Jesus Christ to every Marshallese home — on every atoll and across the diaspora — in the language of the heart.",
    "about.v1t": "Gospel-Centered",
    "about.v1": "Christ crucified and risen is the heart of every program.",
    "about.v2t": "In Our Language",
    "about.v2": "Broadcasting in Marshallese and English for every generation.",
    "about.v3t": "Island to Island",
    "about.v3": "From Majuro to the outer islands and Marshallese families abroad.",
    "about.v4t": "Prayer & Hope",
    "about.v4": "We pray for our listeners and walk with them in faith.",
    "about.faithTitle": "What We Believe",
    "about.faithNote": "[Draft statement — edit to match your church's statement of faith]",
    "about.f1q": "The Bible",
    "about.f1a": "We believe the Bible is the inspired Word of God, our guide for faith and life.",
    "about.f2q": "Jesus Christ",
    "about.f2a": "We believe Jesus Christ is the Son of God, who died for our sins and rose again.",
    "about.f3q": "Salvation",
    "about.f3a": "We believe salvation is by grace through faith in Jesus — a gift for all who choose Him.",
    "about.f4q": "The Church",
    "about.f4a": "We believe in the fellowship of believers, called to love, serve, and share the Good News.",
    "sermons.over": "Library",
    "sermons.title": "Sermons & Messages",
    "sermons.lead": "Listen again to preaching, devotionals, youth messages, and island gospel music.",
    "sermons.search": "Search messages, speakers, scripture…",
    "sermons.empty": "No messages found.",
    "cat.all": "All",
    "cat.sermon": "Sermons",
    "cat.devotional": "Devotionals",
    "cat.music": "Gospel Music",
    "cat.youth": "Youth",
    "audio.soon": "Audio coming soon for this message.",
    "donate.over": "Tithes & Offerings",
    "donate.title": "Give with a cheerful heart.",
    "donate.verse": "\"Each of you should give what you have decided in your heart to give, not reluctantly or under compulsion, for God loves a cheerful giver.\" — 2 Corinthians 9:7",
    "donate.fund": "Choose where your gift goes",
    "donate.tithe": "Tithe",
    "donate.offering": "Offering",
    "donate.radio": "Radio Ministry",
    "donate.amount": "Amount",
    "donate.custom": "Other",
    "donate.cta": "Give",
    "donate.soon": "Online giving is paused right now. To give today, email support@awainkelet.org.",
    "donate.secure": "Secure card payment by Stripe",
    "donate.receipt": "Your details for a receipt (optional)",
    "donate.name": "Name (optional)",
    "donate.email": "Email (optional)",
    "donate.min": "Please enter at least $1.",
    "pay.checking": "Confirming your gift…",
    "pay.thanks": "Kommol tata — thank you!",
    "pay.thanksText": "Your gift has been received. May God bless you for carrying His Word across the islands.",
    "pay.failed": "We couldn't confirm this payment.",
    "pay.failedText": "No money was taken. Please try again, or email support@awainkelet.org.",
    "pay.cancel": "Your gift was cancelled.",
    "pay.cancelText": "No payment was made. You can try again anytime.",
    "pay.again": "Back to giving",
    "pay.home": "Return home",
    "contact.over": "Contact",
    "contact.title": "We would love to hear from you.",
    "contact.lead": "Prayer requests, questions, testimonies, or ways to serve — write to us anytime.",
    "contact.email": "Email us",
    "contact.copy": "Copy",
    "contact.copied": "Email copied",
    "contact.write": "Write an email",
    "contact.phone": "Phone",
    "contact.address": "Studio",
    "contact.freq": "Frequency",
    "footer.rights": "All rights reserved.",
    "footer.privacy": "Privacy Policy",
    "footer.terms": "Terms of Giving",
    "donate.terms": "Terms of Giving",
    "donate.agree": "By giving you agree to our",
    "donate.privacy": "How we handle your details: read our Privacy Policy.",
    "footer.portal": "Team portal",
    "player.live": "LIVE",
    "player.onair": "Awa In Kelet — Live Radio",
    "player.error": "We couldn't start the audio. Please tap play again.",
    "onair.now": "On Air now",
    "ann.title": "Announcements",
    "ann.more": "Learn more",
    "contact.phoneValue": "[+692 000 0000]",
    "contact.addressValue": "[Studio address], Majuro, Marshall Islands",
    "contact.freqValue": "[FM 00.0]",
    "footer.address": "[Studio address] · Majuro, Marshall Islands",
  },
  mh: {
    "nav.home": "Jinoin",
    "nav.about": "Kōn Kōm",
    "nav.sermons": "Kōnnaan",
    "nav.gallery": "Iien ko & Program ko",
    "events.over": "Pija & Vidio",
    "nav.pastors": "Pastor ro",
    "pastors.over": "Pastor ro ad",
    "pastors.title": "Pastor ro & Ri-kwalok naan",
    "pastors.lead": "Jela kaki pastor ro rej kwalok Naan an Anij ilo Awa In Kelet, im lo aolep kōnnaan ko aer ilo juon jikin.",
    "pastors.messages": "kōnnaan",
    "pastors.empty": "Enaaj walōk pastor ro.",
    "pastors.files": "File in kōnnaan",
    "pastors.filesCount": "file",
    "pastors.noFiles": "Ejjeļọk file.",
    "pastors.all": "Aolep pastor ro",
    "pastors.messagesBy": "Kōnnaan ko",
    "pastors.noMessages": "Ejjeļọk kōnnaan.",
    "events.title": "Iien ko & Program ko",
    "events.lead": "Pija im vidio jān program im iien ko ad ilo aelōn̄ ko.",
    "events.empty": "Ejjeļọk pija ak vidio.",
    "events.items": "pija & vidio",
    "events.deptLead": "Pija im vidio jān program im iien ko an department in.",
    "events.all": "Aolep department ko",
    "events.more": "Eloñ lok pija & vidio",
    "sermons.pastor": "Aolep ri-kwalok naan",
    "sermons.watch": "Lale vidio",
    "nav.donate": "Katok",
    "nav.contact": "Kepaake Kōm",
    "cta.listen": "Roñjake Kiiō",
    "cta.explore": "Kōnnaan ko",
    "hero.title1": "Awa In",
    "hero.title2": "Kelet.",
    "hero.over": "Radio in Kristian · Aelōn̄ in Ṃajeḷ",
    "hero.tagline": "Awa in Kālet — Jijej ak Lal In.",
    "hero.sub": "Juon ainikien kōjatdikdik ñan aelōn̄ otemjej. Kwalok Naan, al in jar, im Naan an Anij — raan im bon̄.",
    "hero.scroll": "Lomnak",
    "marquee": "Awa In Kelet ✝ Awa in Kālet ✝ Jijej ak Lal In ✝ Iakwe ✝ Naan an Anij ñan Aelōn̄ Otemjej ✝",
    "choice.over": "Kālet eo",
    "choice.title": "Ruo iaḷ. Juon kālet.",
    "choice.world": "Lal In",
    "choice.worldText": "Ekilep kōjām eo im eḷap iaḷ eo. Elōn̄ an kallimur, ak ej likūt būruōd ilo ejjeḷọk.",
    "choice.jesus": "Jijej",
    "choice.jesusText": "\"Ña iaḷ eo, im mool, im mour.\" Juon iaḷ eaidik — im ej tōprak ñan m̧weo.",
    "choice.verse": "Kāālōt ilo raan in wōn eo kom naaj karejar ñane — Joshua 24:15",
    "featured.over": "Roñjake Eokwe",
    "featured.title": "Kōnnaan ko Ekāāl",
    "featured.all": "Kōnnaan otemjej",
    "schedule.over": "Ilo Radio",
    "schedule.title": "Būrokraam ko an Raan",
    "schedule.note": "[Placeholder — kōkāāl ilo awa ko re mool]",
    "give.title": "Kōjparok Naan eo ilo radio.",
    "give.text": "Katok ko am rej bōk Gospel eo ñan m̧weo otemjej ilo aelōn̄ ko.",
    "give.cta": "Katok Kiiō",
    "about.over": "Kōn Radio eo",
    "about.title": "Juon radio ej jutak ioon juon kajjitōk.",
    "about.lead": "Awa In Kelet ej meļeļein \"Awa in Kālet.\" Aolep būrokraam ej kūr ri-roñjake ñan kālet eo eḷap tata: ñan ḷoor Jijej, ak ñan ḷoor lal in.",
    "about.missionTitle": "Jerbal eo Ad",
    "about.mission": "Ñan bōk Gospel an Jijej Kraist ñan aolep m̧weo an ri-Ṃajeḷ — ilo aelōn̄ otemjej im ijo jabdewōt — ilo kajin eo an būruwōd.",
    "about.v1t": "Jijej ej Ioḷapḷap",
    "about.v1": "Kraist eo ear mej im jerkakpeje ej ioḷapḷap in aolep būrokraam.",
    "about.v2t": "Ilo Kajin Eo Ad",
    "about.v2": "Ilo Kajin Ṃajeḷ im Kajin Pālle ñan aolep epepen.",
    "about.v3t": "Aelōn̄ ñan Aelōn̄",
    "about.v3": "Jen Ṃajro ñan aelōn̄ ko ilikin im baamḷe ko an ri-Ṃajeḷ ilo lal ko jet.",
    "about.v4t": "Jar im Kōjatdikdik",
    "about.v4": "Kōm jar kōn ri-roñjake ro im etetal ippāer ilo tōmak.",
    "about.faithTitle": "Men ko Kōm Tōmak",
    "about.faithNote": "[Draft — kōkāāl ñan an jọkkun ilo kabun eo am]",
    "about.f1q": "Baibōl",
    "about.f1a": "Kōm tōmak bwe Baibōl ej Naan an Anij, tōl eo ad ilo tōmak im mour.",
    "about.f2q": "Jijej Kraist",
    "about.f2a": "Kōm tōmak bwe Jijej Kraist Nejin Anij, eo ear mej kōn jerawiwi ko ad im jerkakpeje.",
    "about.f3q": "Lo-Mour",
    "about.f3a": "Kōm tōmak bwe lo-mour ej kōn jouj, jen tōmak ilo Jijej — menin letok ñan aolep ro rej kāālōt E.",
    "about.f4q": "Kabun eo",
    "about.f4a": "Kōm tōmak ilo kumi eo an ri-tōmak, kūr ñan yokwe, jerbal, im kwalok Naan Eṃṃan.",
    "sermons.over": "Kōnnaan ko",
    "sermons.title": "Kwalok Naan & Kōnnaan",
    "sermons.lead": "Roñjake bar kwalok naan, jar in jibbon̄, kōnnaan ñan jodrikdrik, im al in jar.",
    "sermons.search": "Pukot kōnnaan, ri-kwalok naan, eoon Baibōl…",
    "sermons.empty": "Ejjeļọk kōnnaan.",
    "cat.all": "Aolep",
    "cat.sermon": "Kwalok Naan",
    "cat.devotional": "Jar in Jibbon̄",
    "cat.music": "Al in Jar",
    "cat.youth": "Jodrikdrik",
    "audio.soon": "Ainikien in ej itok tokālik.",
    "donate.over": "Tithe & Katok",
    "donate.title": "Letok kōn būruwōd emōn̄ōn̄ō.",
    "donate.verse": "\"Kwōn letok āinwōt am kar pepe ilo būruōm, jab kōn būruōm nana ak kōn kōkajoor, bwe Anij ej yokwe eo ej letok kōn emōn̄ōn̄ō.\" — 2 Korint 9:7",
    "donate.fund": "Kālet ijo katok eo am ej etal ie",
    "donate.tithe": "Tithe",
    "donate.offering": "Katok",
    "donate.radio": "Jerbal in Radio",
    "donate.amount": "Oñāān",
    "donate.custom": "Jet",
    "donate.cta": "Katok",
    "donate.soon": "Katok ilo online ej bōjrak kiiō. Ñan katok, email support@awainkelet.org.",
    "donate.secure": "Kōllā kōn kaat ilo Stripe ej kōjparok",
    "donate.receipt": "Etam im email ñan receipt (ejjab aikuj)",
    "donate.name": "Etam (ejjab aikuj)",
    "donate.email": "Email (ejjab aikuj)",
    "donate.min": "Jouj im letok $1 ak eḷapḷọk.",
    "pay.checking": "Kōmool katok eo am…",
    "pay.thanks": "Kommol tata!",
    "pay.thanksText": "Kōm ear bōk katok eo am. Anij en kōjeraam̧m̧an eok kōn am jipan̄ bōk Naan eo An ñan aelōn̄ ko.",
    "pay.failed": "Kōm jab maron̄ kōmool kōllā in.",
    "pay.failedText": "Ejjeļọk jāān ear bōk. Jouj im bar kōjeḷọk, ak email support@awainkelet.org.",
    "pay.cancel": "Katok eo am ear kabōjrak.",
    "pay.cancelText": "Ejjeļọk kōllā. Kwōmaron̄ bar kōjeḷọk jabdewōt iien.",
    "pay.again": "Jepḷaak ñan katok",
    "pay.home": "Jepḷaak ñan jinoin",
    "contact.over": "Kepaake Kōm",
    "contact.title": "Kōm kōṇaan roñ jen kwe.",
    "contact.lead": "Kajjitōk in jar, kajjitōk, kanniōk, ak wāween jerbal — jeje ñan kōm jabdewōt iien.",
    "contact.email": "Email kōm",
    "contact.copy": "Kopiiki",
    "contact.copied": "Email eo ekar kopiiki",
    "contact.write": "Jeje email",
    "contact.phone": "Taliboon",
    "contact.address": "Studio",
    "contact.freq": "Frequency",
    "footer.rights": "Aolep jimwe ko rej kōjparoki.",
    "footer.portal": "Jikin team",
    "player.live": "LIVE",
    "player.onair": "Awa In Kelet — Radio Live",
    "player.error": "Jejjab maron̄ jino ainikien eo. Jouj im bar jibwe play.",
    "onair.now": "Ilo Radio kiio",
    "ann.title": "Kōjjeļā",
    "ann.more": "Kile",
    "contact.phoneValue": "[+692 000 0000]",
    "contact.addressValue": "[Studio address], Ṃajro, Aelōn̄ in Ṃajeḷ",
    "contact.freqValue": "[FM 00.0]",
    "footer.address": "[Studio address] · Ṃajro, Aelōn̄ in Ṃajeḷ",
  },
};
